import { Authenticator } from '@aws-amplify/ui-react';

export function LoginRegisterPage() {
  return <Authenticator />;
}
